import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";

import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import shipingService from "../services/shiping-service";
import DatePicker from "react-datepicker";
import moment from "moment";
const tablePropsInit = {
  columns: [
    { key: "fac_id", title: "Facility Id" },
    { key: "fac_name", title: "Facility Name" },
    { key: "box_num", title: "Box Number" },
    { key: "is_last_box", title: "Last Box" },
    { key: "audited_at", title: "Audited Time" },
    { key: "usr_fname", title: "Audited By" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const ShipingReport = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [reportDate, setReportDate] = useState();
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
  };
  const getShipingReports = async () => {
    if (!reportDate) {
      const { hide } = cogoToast.error("Please chose valid date", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    } else {
      try {
        setLoading(true);
        let resp = await shipingService.getShpngReport(
          moment(reportDate).format("YYYY-MM-DD")
        );
        resp.sort((d1, d2) => d1.fac_id - d2.fac_id);
        if (resp.length > 0) {
          dispatch(updateData(resp));
        } else {
          const { hide } = cogoToast.error("No Records Found!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          dispatch(updateData([]));
        }
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while retrieving audit records !",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  };
  useEffect(() => {}, []);
  const CustomCell = ({ rowData }) => {
    return <div>{rowData?.usr_fname + " " + rowData.usr_lname}</div>;
  };
  const CustomCell2 = ({rowData}) => {
    return (
      <div>    
          <span className="inline-block mr-3">{moment.utc(rowData?.audited_at).format('MM-DD-YYYY hh:mm:ss') || ''}</span>          
      </div>
    );
  };
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">AUDIT REPORT</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
          <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-1/4 h-10 focus:outline-none focus:none font-light align-bottom mr-4 mb-3"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 top-1 bottom-3"
              ></img>
            </span>
            <span className="inline-block mb-3">
              <DatePicker
                placeholderText="MM/DD/YYYY"
                selected={reportDate}
                onChange={(date) => {
                  setReportDate(date);
                }}
                className="w-3/4 border h-10 rounded pl-2 text-labelclr font-semibold text-xs tracking-wider mr-4"
              />
            </span>
            <span className="inline-block text-center mr-4">
              <button
                onClick={() => {
                  getShipingReports();
                }}
                type="button"
                className="bg-header_bg rounded py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
              >
                SUBMIT
              </button>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            dispatch={dispatch}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "usr_fname":
                      return <CustomCell {...props} />;
                    case "audited_at":
                      return <CustomCell2 {...props} />;
                  }
                },
              },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ShipingReport)
);
